// Components==============
import schoolIndex from 'actions/school/index';
import React, { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// =========================

export const StoreContext = createContext(null);

export default function StoreContextWrapper({ children }) {
    const dispatch = useDispatch();

    useEffect(() => dispatch(schoolIndex()), []);

    const schools = useSelector((state) => state?.school?.entities);

    return (
        <StoreContext.Provider
            value={{ schools: schools?.allIds.map((e) => schools?.byId[e]) }}
        >
            {children}
        </StoreContext.Provider>
    );
}
